import { Popover as MantinePopover, type PopoverProps } from "@mantine/core";
import type { ReactElement } from "react";

export interface Props extends PopoverProps {
  anchor: ReactElement;
}
const Popover = ({ anchor, classNames, ...rest }: Props) => {
  return (
    <MantinePopover
      position="bottom"
      withArrow
      shadow="md"
      withOverlay
      classNames={{
        overlay: "backdrop-blur-xs",
        ...classNames,
      }}
      {...rest}
    >
      <MantinePopover.Target>
        <div className="w-fit">{anchor}</div>
      </MantinePopover.Target>
      <MantinePopover.Dropdown className="max-h-[80vh] overflow-y-auto">
        {rest.children}
      </MantinePopover.Dropdown>
    </MantinePopover>
  );
};

export default Popover;
